import React from 'react';
import { SideNavContainer } from './SideNav.styles';
import { PageProps } from 'gatsby';
import { IMenuLink } from 'molecules/Header/Header/HeaderLinks';
import Stack from 'atoms/Layout/Stack/Stack';
import SideNavLink from 'molecules/SideNav/SideNavLink';
import Button from 'atoms/Button/Button';
import HeaderCta from 'molecules/Header/Header/HeaderCta';

interface SideNavProps {
  isPro: boolean;
  isOpen: boolean;
  sideBarLinks: IMenuLink[];
  locationProps: PageProps['location'];
}

const SideNav = ({ isPro, isOpen, sideBarLinks, locationProps }: SideNavProps): JSX.Element => {
  return (
    <SideNavContainer
      id='side-nav'
      direction='column'
      isOpen={isOpen}
      position='absolute'
      gap='spacing-2xl'
      background='bg-primary'
      padding={['spacing-8xl', 'spacing-none', 'spacing-none', 'spacing-none']}
    >
      <Stack
        direction='column'
        gap='spacing-xxs'
        align='flex-start'
        justify='flex-start'
      >
        {sideBarLinks.map((link) => (
          <SideNavLink
            key={link.text}
            text={link.text}
            href={link.href}
            trackingSlug={link.trackingSlug}
            useExpandableMenu={link.useExpandableMenu}
            expandableMenu={link.expandableMenu}
            locationPathname={locationProps.pathname}
          />
        ))}
      </Stack>
      <Stack
        align='stretch'
        gap='spacing-lg'
        direction='column'
        className='side-nav-cta'
        padding={['spacing-3xl', 'spacing-xl']}
        marginBottom='spacing-8xl'
        justify='flex-start'
      >
        <HeaderCta callToAction={isPro ? 'pro' : 'standard'} />
        <Button
          size='lg'
          variant='secondary'
          href='https://mightynetworks.com/sign_in'
        >
          Log In
        </Button>
      </Stack>
    </SideNavContainer>
  );
};

export default SideNav;
